import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { setIsDedicatedWorkflow } from '../../redux/modules/workflow/workflow-action-creator';
import QuestionnaireScoring from './QuestionnaireScoring';

class KioskQuestionnaireScoring extends React.Component {
  UNSAFE_componentWillMount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(true));
  }

  componentWillUnmount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(false));
  }

  render() {
    return (
      <QuestionnaireScoring exitAfterFinalQ />
    );
  }
}

KioskQuestionnaireScoring.propTypes = {
  dispatch: PropTypes.func,
};

export default connect()(KioskQuestionnaireScoring);
